import { getMeta } from '@/router/utils';

export default (to, from, next) => {
  const zohoChat = window.$zoho.salesiq.floatbutton;
  const meta = getMeta(to);

  if (meta.hideZohoChat) {
    // eslint-disable-next-line no-unused-expressions
    zohoChat?.visible('hide');
  } else {
    // eslint-disable-next-line no-unused-expressions
    zohoChat?.visible('show');
  }

  return next();
};
